var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"请选择code","size":"small"},on:{"change":_vm.getCty},model:{value:(_vm.fbacode),callback:function ($$v) {_vm.fbacode=$$v},expression:"fbacode"}},_vm._l((_vm.options),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.code+'/'+item.zip,"value":item.code}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }